<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!--<router-view/>-->
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
    #app {
          font-family: 'Avenir', Helvetica, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          margin:0;
          padding:0;
          height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue